export class AutocompleteResult {
  checked: boolean = false;
  id: number;
  label: string;
  value: string;
}
